<template>
  <div class="triptype_box">
    <div
      v-show="isShow&&isSwitch==false"
      class="trip-type main-color"
      @click="check"
    >
      <span :class="[ isActive=='1' ? 'active actived-left' : 'actived-left' ]">{{ $t('A001','因公') }}</span>
      <span :class="[ isActive=='2' ? 'active actived-right' : 'actived-right']">{{ $t('A002','因私') }}</span>
    </div>
    <van-cell
      center
      :title="switchTitle"
      v-show="isSwitch"
    >
      <template #right-icon>
        <van-switch
          v-model="isActive"
          size="20"
          active-value="1"
          inactive-value="2"
          @change="changeSwitch"
        />
      </template>
    </van-cell>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {Cell,Switch } from 'vant'
export default {
  name: 'TripType',
  components:{
    [Switch.name]:Switch,
    [Cell.name]:Cell,
  },
  data() {
    return {
      isActive: '1',
      isShow:true,
    }
  },
  props:{
    isSwitch:{
      type:Boolean,
      default:false
    },
    switchTitle:{
      type:String,
      default:''
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo'
    })
  },
  created() {
    this.$store.commit('SET_TRIPTYPE',1)
    this.$store.commit('RENEW_SERVICE')
    this.isActive = this.$store.state.app.tripType
    this.display()
  },
  methods: {
    check() {
      this.isActive == '1' ? (this.isActive = '2') : (this.isActive = '1')
      this.$store.commit('SET_TRIPTYPE', this.isActive)
      this.$nextTick(() => this.$store.commit('RENEW_SERVICE'))
    },
    display(){//个人支付 散客 企业因私 或者配置
      if((this.userInfo.vipCorp.corpNo=='GRZF') ||(this.userInfo.vipCorp.corpNo=='SK')||(this.userInfo.vipCorp.tripType=='2')){
        this.isActive=2
        this.isShow=false
        this.$store.commit('SET_TRIPTYPE', this.isActive)
        this.$nextTick(() => this.$store.commit('RENEW_SERVICE'))
      }
      if(process.env.VUE_APP_showTripType=='false'){
        this.isShow=false
      }
    },
    changeSwitch(){
      this.$store.commit('SET_TRIPTYPE', this.isActive)
      this.$nextTick(() => this.$store.commit('RENEW_SERVICE'))
    }
  },
  watch: {
    isActive(val) {
      this.$emit('on-change', val)
    },
    type(val) {
      this.isActive = val
    }
  }
}
</script>

<style lang="less" scoped>
.trip-type {
  height: 26px;
  line-height: 26px;
  background-color: #333333;
  border-radius: 12px;
  padding: 1px;
  font-size: @font-size-12;

  .actived-left,
  .actived-right {
    display: inline-block;
    height: 24px;
    padding: 0 6px;
    text-align: center;
    min-width: 50px;
  }


  .active {
    background-color: #ffffff;
    border-radius: 24px;

    transition: width 200ms;
    -moz-transition: width 200ms;
    -webkit-transition: width 200ms;
    -o-transition: width 200ms;
  }

  background-color: #333333;
  border-radius: 26px;
}
</style>
